
import { useIntl, getLocale } from 'umi';


export const useLocal = (namespace = '', delimiter = '_',) => {
  const { formatMessage } = useIntl();
  const locale = getLocale()

  const getLocalText = (id: any, config = {}, isConcat = true) => {
    const messageId = (() => {
      if (isConcat) {
        return namespace ? `${namespace}${delimiter}${id}` : id
      }
      return id
    })()

    return formatMessage({
      id: messageId
    }, config)
  }

  return {
    locale,
    isEN: locale === 'en-US',
    isCH: locale === 'zh-CN',
    getLocalText,
  }
}

